import { createReducer, on } from "@ngrx/store";

import { ProductActions } from "./index";
import { Product } from "./product.model";

export interface ProductState {
  availableProductsDetails: Product[] | null;
}

export const initialState: ProductState = {
  availableProductsDetails: [],
};

// Same order GET /products returns, so a reload doesn't reorder the list.
function upsertProduct(products: Product[] | null, product: Product) {
  return [...(products || []).filter(p => p.id !== product.id), product].sort(
    (a, b) => (a.name ?? "").localeCompare(b.name ?? "")
  );
}

export const productReducer = createReducer(
  initialState,

  on(
    ProductActions.getAvailableProductDetailsSuccess,
    (state, { products }) => ({
      ...state,
      availableProductsDetails: products,
    })
  ),

  on(
    ProductActions.createProductSuccess,
    ProductActions.editProductSuccess,
    (state, { product }) => ({
      ...state,
      availableProductsDetails: upsertProduct(
        state.availableProductsDetails,
        product
      ),
    })
  )
);
